import { useQuery } from "react-query";
import { getOfficeDepartment } from "../../../../../actions/Utilities/OfficeDepartment";

export default function GetOfficeDepartment() {
  return useQuery("GetOfficeDepartment", getOfficeDepartment, {
    refetchOnWindowFocus: false,
  });
}
